<template>

    <div class="flex w-full pt-4 pb-2 px-4 bg-gray-100"
        v-show="messages.filter((message) => {
            return types.indexOf(message.type) > -1 || message.type === 'any'
        }).length > 0">

        <div class="list-disc pl-10 mb-3">

            <div class="list-item"
                :class="`text-${ message.color }-600`"
                v-for="message in messages"
                v-if="types.indexOf(message.type) > -1 || message.type === 'any'">

                <span v-html="message.text" />

                <font-awesome-icon
                    v-show="message.spin"
                    :icon="['fad', 'spinner-third']"
                    spin
                    size="sm"
                ></font-awesome-icon>

            </div>

        </div>

    </div>

</template>

<script>
export default {

    name: "Messages",

    props: {

        types: {
            type: Array,
            default: () => {
                return []
            }
        }

    },

}
</script>
